module.exports = __webpack_public_path__ + "static/circle-3-5443ced302b09cbfdd411daecf01e69a.svg";